import React from 'react';

import { useTransition, animated } from 'react-spring';

function PageTransition({children}) {
  const trans = useTransition(true, null, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: { duration: 250}
  });
  return trans.map(
    ({ item, key, props }) => item && <animated.div style={props} key={key}>{children}</animated.div>
  );
}
export default PageTransition;
